

const Home = () => {
return (<>
    <div> Main content in home</div>
</>)
}

export default Home;